module.exports = __webpack_public_path__ + "media/images/home/starting_at_badge-6ad774ac1fcd138c082e8f940ea70381.svg";